export const ActionTypes = {
  SET_LOADER_STATUS: 'services/reports/set_loader_status',

  FETCH_ENERGY_REPORT: 'services/reports/fetch_energy_report',
  SET_ENERGY_REPORT: 'services/reports/set_energy_report',

  FETCH_FACTORY_REPORT: 'services/reports/fetch_factory_report',
  SET_FACTORY_REPORT: 'services/reports/set_factory_report',

  FETCH_FACTORY_DETAIL_REPORT: 'services/reports/fetch_factory_detail_report',
  SET_FACTORY_DETAIL_REPORT: 'services/reports/set_factory_detail_report',

  FETCH_FACTORY_OEE_REPORT: 'services/reports/fetch_factory_oee_report',
  SET_FACTORY_OEE_REPORT: 'services/reports/set_factory_oee_report',
  FETCH_FACTORY_AVAILABILITY_REPORT: 'services/reports/fetch_factory_availability_report',
  SET_FACTORY_AVAILABILITY_REPORT: 'services/reports/set_factory_availability_report',
  FETCH_FACTORY_PERFORMANCE_REPORT: 'services/reports/fetch_factory_performance_report',
  SET_FACTORY_PERFORMANCE_REPORT: 'services/reports/set_factory_performance_report',
  FETCH_FACTORY_QUALITY_REPORT: 'services/reports/fetch_factory_quality_report',
  SET_FACTORY_QUALITY_REPORT: 'services/reports/set_factory_quality_report',

  FETCH_FACTORY_DAY_REPORT: 'services/reports/fetch_factory_day_report',
  SET_FACTORY_DAY_REPORT: 'services/reports/set_factory_day_report',

  FETCH_SHIFT_REPORT: 'services/reports/fetch_shift_report',
  SET_SHIFT_REPORT: 'services/reports/set_shift_report',

  FETCH_EQUIPMENT_DOWNTIMES: 'services/reports/fetch_equipment_downtimes',
  SET_EQUIPMENT_DOWNTIMES: 'services/reports/set_equipment_downtimes',

  FETCH_EQUIPMENT_EFFICIENCY_REPORT: 'services/reports/fetch_equipment_efficiency_report',
  SET_EQUIPMENT_EFFICIENCY_REPORT: 'services/reports/set_equipment_efficiency_report',
  FETCH_EQUIPMENT_OEE_REPORT: 'services/reports/fetch_equipment_oee_report',
  SET_EQUIPMENT_OEE_REPORT: 'services/reports/set_equipment_oee_report',
  FETCH_EQUIPMENT_AVAILABILITY_REPORT: 'services/reports/fetch_equipment_availability_report',
  SET_EQUIPMENT_AVAILABILITY_REPORT: 'services/reports/set_equipment_availability_report',
  FETCH_EQUIPMENT_PERFORMANCE_REPORT: 'services/reports/fetch_equipment_performance_report',
  SET_EQUIPMENT_PERFORMANCE_REPORT: 'services/reports/set_equipment_performance_report',
  FETCH_EQUIPMENT_QUALITY_REPORT: 'services/reports/fetch_equipment_quality_report',
  SET_EQUIPMENT_QUALITY_REPORT: 'services/reports/set_equipment_quality_report',

  FETCH_PRODUCT_EFFICIENCY_REPORT: 'services/reports/fetch_product_efficiency_report',
  SET_PRODUCT_EFFICIENCY_REPORT: 'services/reports/set_product_efficiency_report',
  FETCH_REJECTION_REPORT: 'services/reports/fetch_rejection_report',
  FETCH_DOWNTIME_REPORT: 'services/reports/fetch_downtime_report',
  FETCH_CUSTOM_JOB_REPORT: 'services/reports/fetch_Ccustom_job_report',
  SET_REJECTION_REPORT: 'services/reports/set_rejection_report',
  SET_DOWNTIME_REPORT: 'services/reports/set_downtime_report',
  SET_CUSTOM_JOB_REPORT: 'services/reports/set_custom_job_report',
  FETCH_DOWNTIME_ANALYSIS_REPORT: 'services/reports/fetch_downtime_analysis_report',
  SET_DOWNTIME_ANALYSIS_REPORT: 'services/reports/set_downtime_analysis_report',
  FETCH_TOOL_ANALYSIS_REPORT: 'services/reports/fetch_tool_analysis_report',
  SET_TOOL_ANALYSIS_REPORT: 'services/reports/set_tool_analysis_report',
  FETCH_JOB_REPORT: 'services/reports/fetch_job_report',
  SET_JOB_REPORT: 'services/reports/set_job_report',

  FETCH_UNIT_TYPE_BY_FACTORY: 'services/reports/fetch_unit_type_by_factory',
  SET_UNIT_TYPE_BY_FACTORY: 'services/reports/set_unit_type_by_factory',

  FETCH_EQUIPMENTS_BY_GROUP: 'services/reports/fetch_equipments_by_group',
  FETCH_LINES_BY_GROUP: 'services/reports/fetch_lines_by_group',
  SET_EQUIPMENTS_BY_GROUP: 'services/reports/set_equipments_by_group',
  SET_LINES_BY_GROUP: 'services/reports/set_lines_by_group',

  SET_FACTORY_REPORT_FILTERS: 'services/reports/set_factory_report_filters',
  SET_SHIFT_REPORT_FILTERS: 'services/reports/set_shift_report_filters',
  SET_JOB_REPORT_FILTERS: 'services/reports/set_job_report_filters',
  SET_EQUIPMENT_REPORT_FILTERS: 'services/reports/set_equipment_report_filters',
  SET_ENERGY_REPORT_FILTERS: 'services/reports/set_energy_report_filters',
  SET_DOWNITME_REPORT_FILTERS: 'services/reports/set_downtime_report_filters',
  SET_REJECTION_REPORT_FILTERS: 'services/reports/set_rejection_report_filters',
  SET_CUSTOM_DOWNTIME_REPORT_FILTERS: 'services/reports/set_custom_downtime_report_filters',
  //Power BI
  FETCH_POWER_BI_TOKEN: 'services/reports/fetch_power_bi_token',
  SET_POWER_BI_TOKEN: 'services/reports/set_power_bi_token',
  REFRESH_POWER_BI_DATASET: 'services/reports/refresh_power_bi_dataset',
  EXPORT_TO_FILE_IN_GROUP: 'services/reports/export_to_file_in_group',

  //Factory summary report
  FETCH_FACTORY_SUMMARY_REPORT: 'services/reports/fetch_factory_summary_report',
  SET_FACTORY_SUMMARY_REPORT: 'services/reports/set_factory_summary_report',
};

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchFactoryReport = ({ factoryReportParams }) => ({
  factoryReportParams,
  type: ActionTypes.FETCH_FACTORY_REPORT,
});

const setFactoryReport = ({ factoryReport }) => ({
  factoryReport,
  type: ActionTypes.SET_FACTORY_REPORT,
});

const fetchFactoryOeeReport = ({ factoryReportParams }) => ({
  factoryReportParams,
  type: ActionTypes.FETCH_FACTORY_OEE_REPORT,
});

const setFactoryOeeReport = ({ factoryOeeReport }) => ({
  factoryOeeReport,
  type: ActionTypes.SET_FACTORY_OEE_REPORT,
});

const fetchFactoryAvailabilityReport = ({ factoryReportParams }) => ({
  factoryReportParams,
  type: ActionTypes.FETCH_FACTORY_AVAILABILITY_REPORT,
});

const setFactoryAvailabilityReport = ({ factoryAvailabilityReport }) => ({
  factoryAvailabilityReport,
  type: ActionTypes.SET_FACTORY_AVAILABILITY_REPORT,
});

const fetchFactoryPerformanceReport = ({ factoryReportParams }) => ({
  factoryReportParams,
  type: ActionTypes.FETCH_FACTORY_PERFORMANCE_REPORT,
});

const setFactoryPerformanceReport = ({ factoryPerformanceReport }) => ({
  factoryPerformanceReport,
  type: ActionTypes.SET_FACTORY_PERFORMANCE_REPORT,
});

const fetchFactoryQualityReport = ({ factoryReportParams }) => ({
  factoryReportParams,
  type: ActionTypes.FETCH_FACTORY_QUALITY_REPORT,
});

const setFactoryQualityReport = ({ factoryQualityReport }) => ({
  factoryQualityReport,
  type: ActionTypes.SET_FACTORY_QUALITY_REPORT,
});

const setFactoryReportFilters = ({ factoryReportFilters }) => ({
  factoryReportFilters,
  type: ActionTypes.SET_FACTORY_REPORT_FILTERS,
});

const fetchFactoryDetailReport = ({ factoryDetailReportParams }) => ({
  factoryDetailReportParams,
  type: ActionTypes.FETCH_FACTORY_DETAIL_REPORT,
});

const setFactoryDetailReport = ({ factoryDetailReport }) => ({
  factoryDetailReport,
  type: ActionTypes.SET_FACTORY_DETAIL_REPORT,
});

const fetchFactoryDayReport = ({ factoryDayReportParams }) => ({
  factoryDayReportParams,
  type: ActionTypes.FETCH_FACTORY_DAY_REPORT,
});

const setFactoryDayReport = ({ factoryDayReport }) => ({
  factoryDayReport,
  type: ActionTypes.SET_FACTORY_DAY_REPORT,
});

const fetchEnergyReport = ({ energyReportParams }) => ({
  energyReportParams,
  type: ActionTypes.FETCH_ENERGY_REPORT,
});

const setEnergyReport = ({ energyReport }) => ({
  energyReport,
  type: ActionTypes.SET_ENERGY_REPORT,
});

const setEnergyReportFilters = ({ energyReportFilters }) => ({
  energyReportFilters,
  type: ActionTypes.SET_ENERGY_REPORT_FILTERS,
});

const fetchShiftReport = ({ shiftReportParams }) => ({
  shiftReportParams,
  type: ActionTypes.FETCH_SHIFT_REPORT,
});

const setShiftReport = ({ shiftReport }) => ({
  shiftReport,
  type: ActionTypes.SET_SHIFT_REPORT,
});

const fetchEquipmentDowntimes = ({ equipmentDowntimesParams }) => ({
  equipmentDowntimesParams,
  type: ActionTypes.FETCH_EQUIPMENT_DOWNTIMES,
});

const setEquipmentDowntimes = ({ equipmentDowntimes }) => ({
  equipmentDowntimes,
  type: ActionTypes.SET_EQUIPMENT_DOWNTIMES,
});

const fetchEquipmentEfficiencyReport = ({ equipmentEfficiencyReportParams }) => ({
  equipmentEfficiencyReportParams,
  type: ActionTypes.FETCH_EQUIPMENT_EFFICIENCY_REPORT,
});

const setEquipmentEfficiencyReport = ({ equipmentEfficiencyReport }) => ({
  equipmentEfficiencyReport,
  type: ActionTypes.SET_EQUIPMENT_EFFICIENCY_REPORT,
});

const setEquipmentReportFilters = ({ equipmentReportFilters }) => ({
  equipmentReportFilters,
  type: ActionTypes.SET_EQUIPMENT_REPORT_FILTERS,
});

const fetchEquipmentOeeReport = ({ equipmentReportParams }) => ({
  equipmentReportParams,
  type: ActionTypes.FETCH_EQUIPMENT_OEE_REPORT,
});

const setEquipmentOeeReport = ({ equipmentOeeReport }) => ({
  equipmentOeeReport,
  type: ActionTypes.SET_EQUIPMENT_OEE_REPORT,
});

const fetchEquipmentAvailabilityReport = ({ equipmentReportParams }) => ({
  equipmentReportParams,
  type: ActionTypes.FETCH_EQUIPMENT_AVAILABILITY_REPORT,
});

const setEquipmentAvailabilityReport = ({ equipmentAvailabilityReport }) => ({
  equipmentAvailabilityReport,
  type: ActionTypes.SET_EQUIPMENT_AVAILABILITY_REPORT,
});

const fetchEquipmentPerformanceReport = ({ equipmentReportParams }) => ({
  equipmentReportParams,
  type: ActionTypes.FETCH_EQUIPMENT_PERFORMANCE_REPORT,
});

const setEquipmentPerformanceReport = ({ equipmentPerformanceReport }) => ({
  equipmentPerformanceReport,
  type: ActionTypes.SET_EQUIPMENT_PERFORMANCE_REPORT,
});

const fetchEquipmentQualityReport = ({ equipmentReportParams }) => ({
  equipmentReportParams,
  type: ActionTypes.FETCH_EQUIPMENT_QUALITY_REPORT,
});

const setEquipmentQualityReport = ({ equipmentQualityReport }) => ({
  equipmentQualityReport,
  type: ActionTypes.SET_EQUIPMENT_QUALITY_REPORT,
});

const fetchProductEfficiencyReport = ({ productEfficiencyReportParams }) => ({
  productEfficiencyReportParams,
  type: ActionTypes.FETCH_PRODUCT_EFFICIENCY_REPORT,
});

const setProductEfficiencyReport = ({ productEfficiencyReport }) => ({
  productEfficiencyReport,
  type: ActionTypes.SET_PRODUCT_EFFICIENCY_REPORT,
});

const fetchRejectionReport = ({ rejectionReportParams }) => ({
  rejectionReportParams,
  type: ActionTypes.FETCH_REJECTION_REPORT,
});

const fetchDowntimeReport = ({ downtimeReportParams }) => ({
  downtimeReportParams,
  type: ActionTypes.FETCH_DOWNTIME_REPORT,
});

const fetchCustomJobReport = ({ jobReportParams }) => ({
  jobReportParams,
  type: ActionTypes.FETCH_CUSTOM_JOB_REPORT,
});

const setRejectionReport = ({ rejectionReport }) => ({
  rejectionReport,
  type: ActionTypes.SET_REJECTION_REPORT,
});

const setDowntimeReport = ({ downtimeReport }) => ({
  downtimeReport,
  type: ActionTypes.SET_DOWNTIME_REPORT,
});

const setCustomJobReport = ({ customJobReport }) => ({
  customJobReport,
  type: ActionTypes.SET_CUSTOM_JOB_REPORT,
});

const fetchDowntimeAnalysisReport = ({ downtimeAnalysisReportParams }) => ({
  downtimeAnalysisReportParams,
  type: ActionTypes.FETCH_DOWNTIME_ANALYSIS_REPORT,
});

const setDowntimeAnalysisReport = ({ downtimeAnalysisReport }) => ({
  downtimeAnalysisReport,
  type: ActionTypes.SET_DOWNTIME_ANALYSIS_REPORT,
});

const setDowntimeReportFilters = ({ downtimeReportFilters }) => ({
  downtimeReportFilters,
  type: ActionTypes.SET_DOWNITME_REPORT_FILTERS,
});

const fetchToolAnalysisReport = ({ toolAnalysisReportParams }) => ({
  toolAnalysisReportParams,
  type: ActionTypes.FETCH_TOOL_ANALYSIS_REPORT,
});

const setToolAnalysisReport = ({ toolAnalysisReport }) => ({
  toolAnalysisReport,
  type: ActionTypes.SET_TOOL_ANALYSIS_REPORT,
});

const fetchJobReport = ({ jobReportParams }) => ({
  jobReportParams,
  type: ActionTypes.FETCH_JOB_REPORT,
});

const setJobReport = ({ jobReport }) => ({
  jobReport,
  type: ActionTypes.SET_JOB_REPORT,
});

const fetchUnitTypeByFactory = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_UNIT_TYPE_BY_FACTORY,
});

const setUnitTypeByFactory = ({ factoryUnits }) => ({
  factoryUnits,
  type: ActionTypes.SET_UNIT_TYPE_BY_FACTORY,
});

const fetchEquipmentsByGroup = ({ groupId }) => ({
  groupId,
  type: ActionTypes.FETCH_EQUIPMENTS_BY_GROUP,
});

const fetchLinesByGroup = ({ groupId }) => ({
  groupId,
  type: ActionTypes.FETCH_LINES_BY_GROUP,
});

const setEquipmentsByGroup = ({ groupEquipments }) => ({
  groupEquipments,
  type: ActionTypes.SET_EQUIPMENTS_BY_GROUP,
});

const setLinesByGroup = ({ groupLines }) => ({
  groupLines,
  type: ActionTypes.SET_LINES_BY_GROUP,
});

const setJobReportFilters = ({ jobReportFilters }) => ({
  jobReportFilters,
  type: ActionTypes.SET_JOB_REPORT_FILTERS,
});

const setShiftReportFilters = ({ shiftReportFilters }) => ({
  shiftReportFilters,
  type: ActionTypes.SET_SHIFT_REPORT_FILTERS,
});

const setRejectionReportFilters = ({ rejectionReportFilters }) => ({
  rejectionReportFilters,
  type: ActionTypes.SET_REJECTION_REPORT_FILTERS,
});

const setCustomDowntimeReportFilters = ({ customDowntimeReportFilters }) => ({
  customDowntimeReportFilters,
  type: ActionTypes.SET_CUSTOM_DOWNTIME_REPORT_FILTERS,
});

//Power BI
const fetchPowerBiToken = ({ reportName }) => ({
  reportName,
  type: ActionTypes.FETCH_POWER_BI_TOKEN,
});

const setPowerBiEmbedData = ({ powerBiApiEmbedData }) => ({
  powerBiApiEmbedData,
  type: ActionTypes.SET_POWER_BI_TOKEN,
});

const refreshPowerBIReportDataset = ({ reportName }) => ({
  reportName,
  type: ActionTypes.REFRESH_POWER_BI_DATASET,
});
const exportToFileInGroup = ({ reportName, fileFormat, userEmail }) => ({
  reportName,
  fileFormat,
  userEmail,
  type: ActionTypes.EXPORT_TO_FILE_IN_GROUP,
});

const fetchFactorySummaryReport = ({ factoryReportParams }) => ({
  factoryReportParams,
  type: ActionTypes.FETCH_FACTORY_SUMMARY_REPORT,
});

const setFactorySummaryReport = ({ factorySummaryReportData }) => ({
  factorySummaryReportData,
  type: ActionTypes.SET_FACTORY_SUMMARY_REPORT,
});

export default {
  setLoader,
  fetchFactoryReport,
  setFactoryReport,
  fetchFactoryOeeReport,
  setFactoryOeeReport,
  fetchFactoryAvailabilityReport,
  setFactoryAvailabilityReport,
  fetchFactoryPerformanceReport,
  setFactoryPerformanceReport,
  fetchFactoryQualityReport,
  setFactoryQualityReport,
  setFactoryReportFilters,
  fetchFactoryDetailReport,
  setFactoryDetailReport,
  fetchFactoryDayReport,
  setFactoryDayReport,
  fetchEnergyReport,
  setEnergyReport,
  setEnergyReportFilters,
  fetchShiftReport,
  setShiftReport,
  fetchEquipmentDowntimes,
  setEquipmentDowntimes,
  setShiftReportFilters,
  fetchEquipmentEfficiencyReport,
  setEquipmentEfficiencyReport,
  setEquipmentReportFilters,
  fetchEquipmentOeeReport,
  setEquipmentOeeReport,
  fetchEquipmentAvailabilityReport,
  setEquipmentAvailabilityReport,
  fetchDowntimeReport,
  setCustomJobReport,
  fetchCustomJobReport,
  fetchEquipmentPerformanceReport,
  setEquipmentPerformanceReport,
  fetchEquipmentQualityReport,
  setEquipmentQualityReport,
  fetchProductEfficiencyReport,
  setProductEfficiencyReport,
  fetchRejectionReport,
  setRejectionReport,
  setDowntimeReport,
  setRejectionReportFilters,
  setCustomDowntimeReportFilters,
  fetchDowntimeAnalysisReport,
  setDowntimeAnalysisReport,
  setDowntimeReportFilters,
  fetchToolAnalysisReport,
  setToolAnalysisReport,
  fetchJobReport,
  setJobReport,
  setJobReportFilters,
  fetchUnitTypeByFactory,
  setUnitTypeByFactory,
  fetchEquipmentsByGroup,
  fetchLinesByGroup,
  setEquipmentsByGroup,
  setLinesByGroup,
  fetchPowerBiToken,
  setPowerBiEmbedData,
  refreshPowerBIReportDataset,
  exportToFileInGroup,
  fetchFactorySummaryReport,
  setFactorySummaryReport,
};
